import { ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { storageAvailable } from '../../util/helpers';
var FlyingclubPageComponent = /** @class */ (function () {
    function FlyingclubPageComponent(_route, _meta, _title, _errorHandler) {
        this._route = _route;
        this._meta = _meta;
        this._title = _title;
        this._errorHandler = _errorHandler;
    }
    FlyingclubPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._route.data
            .subscribe(function (data) {
            _this.business = data.business;
            _this._updateMeta(data.business);
        }, function (error) {
            _this._errorHandler.handleError(error);
        });
    };
    FlyingclubPageComponent.prototype._updateMeta = function (business) {
        var title = business.name;
        var airport = this.business.airports[0];
        if (airport) {
            title += " at " + airport.identifier;
        }
        this._title.setTitle(title + " - " + environment.appName);
        this._meta.removeTag('name="description"');
    };
    Object.defineProperty(FlyingclubPageComponent.prototype, "airportIdent", {
        /**
         * Returns the airport identifier to use for the "Back to [airport]" link in the header. If the user navigated to
         * the business page from an airport page, then the referer airport should be used (stored in sessionStorage).
         * Otherwise, this will use the first associated airport for the business. If the business is not associated with
         * any airport, this will return null.
         * @returns {string|null}
         */
        get: function () {
            if (!this.business) {
                return null;
            }
            // Get the associated airports (usually, there is only one, but a business may be associated with multiple
            // airports)
            var associatedAirports = this.business.airports || [];
            // Check if there was an airport set in sessionStorage, and that airport is associated with this business.
            if (storageAvailable('sessionStorage')) {
                var lastAirport_1 = sessionStorage.getItem('lastAirport');
                if (lastAirport_1 && associatedAirports.some(function (airport) { return airport.identifier === lastAirport_1; })) {
                    return lastAirport_1;
                }
            }
            // Otherwise, return the identifier of the first associated airport (or null if there are no associated airports).
            return associatedAirports.length ? associatedAirports[0].identifier : null;
        },
        enumerable: true,
        configurable: true
    });
    return FlyingclubPageComponent;
}());
export { FlyingclubPageComponent };
